import React, { useEffect, memo } from 'react';
import { toast } from 'react-toastify';

import { Space } from 'v2/components/Shared/Space';
import TopPage from 'v2/components/Shared/TopPage';
import affiliationsService from 'v2/services/affiliations';

import { List } from './List';

const Affiliations = () => {
  useEffect(() => {
    affiliationsService.loadAffiliations().subscribe(() => {}, toast.error);
  }, []);

  return (
    <>
      <TopPage title='Minhas Afiliações' extra='Gerencie suas afiliações.' />
      <Space axis='vertical' size={16} />
      <List />
    </>
  );
};

export default memo(Affiliations);
